import { Stack } from "@/Components/v2/atoms/Stack";
import { Typography } from "@/Components/v2/atoms/Typography";

interface NoDataProps {
  title: string;
  description: string;
}

export const NoData: React.FC<NoDataProps> = ({ title, description }) => {
  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      spacing={2}
      padding={3}
      paddingX={10}
      margin={4}
      borderRadius={4}
    >
      <Typography variant="h5" fontWeight={600} paddingTop={4}>
        {title}
      </Typography>
      <Typography variant="body1">{description}</Typography>
    </Stack>
  );
};

export default NoData;
